<template>
  <div class="boxCadastroEndereco mt-4 mb-2">
    <div v-if="!noHeader"
         class="boxCadastroEndereco_header">
      Endereço
    </div>
    <div class="boxCadastroEndereco_body"
         :class="{ 'pt-3': !noHeader }">
      <form name="cadastroEndereco"
            novalidate
            @submit.prevent="() => {}">
        <slot name="radios" />
        <div v-if="propMostrarExterior"
             class="row no-gutters">
          <div class="form-group">
            <span class="custom-control custom-switch mr-4">
              <input :id="`foraBrasil-${ _uid }`"
                     v-model="localData.exterior"
                     class="custom-control-input foraBrasil"
                     name="tipo_registro"
                     type="checkbox"
                     :value="1"
                     @change="setExterior"
                     @keyup.enter="changeExterior()">
              <label class="custom-control-label"
                     :for="`foraBrasil-${ _uid }`">Fora do Brasil</label>
            </span>
          </div>
        </div>

        <div v-if="localData.exterior && !propGenitorFalecido">
          <div class="row">
            <div class="col-2">
              <div class="form-group">
                <label for="pais"
                       class="label">Pais</label>
                <v-select v-model="localData.pais"
                          v-validate="{ required: !valid }"
                          :options="selectsOptions.paises.map(res => res.nome)"
                          :class="{ 'is-invalid': errors.has('pais') }"
                          class="form-control form-control-sm"
                          name="pais"
                          @input="paisChanged" />
              </div>
            </div>


            <div class="col-12">
              <div class="form-group">
                <label class="label"
                       :for="`endereco-${id}_${ _uid }`">Endereço declarado pelo cidadão</label>

                <textarea :id="`endereco-${id}_${ _uid }`"
                          ref="logradouro"
                          v-model="localData.logradouro"
                          name="endereco"
                          placeholder="Rua Alguma Coisa"
                          class="form-control form-control-sm"
                          cols="30"
                          rows="5"
                          @change="updated" />
              </div>
            </div>
          </div>
        </div>

        <div v-if="!localData.exterior">
          <div class="d-flex justify-content-between">
            <div v-if="enderecoDisable"
                 class="row align-items-end">
              <div class="col-6">
                <div class="form-group">
                  <label class="label"
                         :for="`cep-${id}`">CEP</label>
                  <input :id="`cep-${id}`"
                         v-model="localData.cep"
                         v-mask="'99999-999'"
                         class="form-control form-control-sm"
                         name="cep"
                         :disabled="disabled || !!localData.exterior"
                         placeholder="00000-000"
                         type="text"
                         @keydown="search"
                         @change="getCEP">
                </div>
              </div>

              <div class="form-group">
                <button class="btn btn-sm btn-primary"
                        type="button"
                        :disabled="disabled || !!localData.exterior"
                        @click="getCEP">
                  Pesquisar CEP
                </button>
              </div>
            </div>
            <div v-if="propLocalizacao"
                 class="d-flex align-items-center">
              <button class="btn btn-sm btn-outline-secondary btn-get-coord"
                      @click="getCoords">
                <IconSvg class="icon-location icon--sm"
                         icon="location" />
                Localizar endereço
              </button>
            </div>
          </div>
          <div v-if="enderecoDisable"
               class="row">
            <div class="col-sm-5">
              <div class="form-group">
                <label class="label"
                       :for="`endereco-${id}_${ _uid }`">Endereço</label>
                <input :id="`endereco-${id}_${ _uid }`"
                       ref="logradouro"
                       v-model="localData.logradouro"
                       class="form-control form-control-sm"
                       name="endereco"
                       placeholder="Rua Alguma Coisa"
                       :disabled="disabled"
                       type="text"
                       @change="updated">
              </div>
            </div>

            <div class="col-sm-3 col-lg-2">
              <div class="form-group">
                <label class="label"
                       :for="`numero-${id}_${ _uid }`">Número</label>
                <input :id="`numero-${id}_${ _uid }`"
                       ref="numero"
                       v-model="localData.numero"
                       v-validate="{ required: !!localData.logradouro }"
                       class="form-control form-control-sm"
                       name="numero"
                       placeholder="000"
                       :disabled="disabled || !!localData.exterior"
                       :class="{ 'is-invalid': errors.has('numero') }"
                       type="text"
                       @change="updated">
                <small class="invalid-feedback">{{ errors.first('numero') }}</small>
              </div>
            </div>

            <div class="col-sm-4 col-lg-3 col-xl-2">
              <div class="form-group">
                <label class="label"
                       :for="`complemento-${id}_${ _uid }`">Complemento</label>
                <input :id="`complemento-${id}_${ _uid }`"
                       v-model="localData.complemento"
                       class="form-control form-control-sm"
                       name="complemento"
                       placeholder="Casa"
                       :disabled="disabled || !!localData.exterior"
                       type="text"
                       @change="updated">
              </div>
            </div>
          </div>
          <div class="row">
            <div v-if="enderecoDisable"
                 class="col">
              <div class="form-group">
                <label class="label"
                       :for="`bairro-${id}_${ _uid }`">Bairro</label>
                <input :id="`bairro-${id}_${ _uid }`"
                       v-model="localData.bairro"
                       class="form-control form-control-sm"
                       name="bairro"
                       placeholder="Ex: Tatuapé"
                       :disabled="disabled || !!localData.exterior"
                       type="text"
                       @change="updated">
              </div>
            </div>
            <div v-if="!localData.exterior || enderecoDisable"
                 class="col-2">
              <div class="form-group">
                <label for="estado"
                       class="label">UF<span v-if="propValidator"
                                             class="text-danger"> * </span></label>
                <v-select v-model="localData.uf "
                          v-validate="{ required: valid }"
                          :options="selectsOptions.states.map((state)=>state.uf)"
                          :class="{'is-invalid': errors.has('estado')}"
                          class="form-control form-control-sm"
                          name="estado"
                          :disabled="disabled || !!localData.exterior"
                          @input="stateChanged" />
                <small class="invalid-feedback">{{ errors.first('estado') }}</small>
              </div>
            </div>

            <div v-if="!localData.exterior || enderecoDisable"
                 class="col-4">
              <div class="form-group">
                <label for="estado"
                       class="label">Cidade<span v-if="propValidator"
                                                 class="text-danger"> * </span></label>
                <v-select v-model="localData.cidade "
                          v-validate="{ required: valid }"
                          :options="cidades.map(res => res.nome)"
                          :class="{ 'is-invalid': errors.has('cidade') }"
                          class="form-control form-control-sm"
                          name="cidade"
                          :searchable="localData.uf !== 'EX'"
                          :taggable="localData.uf !== 'EX'"
                          :disabled="disabled || !!localData.exterior"
                          @input="changeIbge" />
                <small class="invalid-feedback">{{ errors.first('cidade') }}</small>
              </div>
            </div>

            <div v-if="localData.exterior && enderecoDisable"
                 class="col-2">
              <div class="form-group">
                <label for="pais"
                       class="label">Pais</label>
                <v-select v-model="localData.pais"
                          v-validate="{ required: !valid }"
                          :options="selectsOptions.paises.map(res => res.nome)"
                          :class="{ 'is-invalid': errors.has('pais') }"
                          class="form-control form-control-sm"
                          name="pais"
                          :disabled="disabled || !localData.exterior"
                          @input="paisChanged" />
              </div>
            </div>

            <div v-if="localData.cidade === 'Outro'"
                 class="col">
              <div class="form-group">
                <label for="cidade_declarada"
                       class="label">Cidade Declarada</label>
                <input :id="`cidade_declarada-${id}_${ _uid }`"
                       v-model="localData.cidade_declarada"
                       v-validate="{ required: localData.cidade === 'Outro' }"
                       class="form-control form-control-sm"
                       name="cidade_declarada"
                       type="text"
                       placeholder="Ex: São Paulo"
                       :class="{ 'is-invalid': errors.has('cidade_declarada') }"
                       @change="updated">
                <small class="invalid-feedback">{{ errors.first('cidade_declarada') }}</small>
              </div>
            </div>
            <div v-if="showCadastroIbge"
                 class="col">
              <div class="form-group">
                <label for="codigo_ibge"
                       class="label">Código IBGE</label>
                <input :id="`codigo_ibge-${id}_${ _uid }`"
                       v-model="localData.ibge"
                       v-validate="{ required: showCadastroIbge }"
                       class="form-control form-control-sm"
                       name="codigo_ibge"
                       type="number"
                       placeholder="00000"
                       :class="{ 'is-invalid': errors.has('codigo_ibge') }"
                       @change="updated">
                <small class="invalid-feedback">{{ errors.first('codigo_ibge') }}</small>
              </div>
            </div>
            <div v-if="!!propGenitorFalecido"
                 class="col-3">
              <div class="form-group">
                <label class="label"
                       :for="`dataFalecimento-${id}_${ _uid }`">Data do falecimento</label>
                <input :id="`dataFalecimento-${id}_${ _uid }`"
                       ref="dataFalecimento"
                       v-model="data_falecimento"
                       v-validate="`date_format:yyyy-MM-dd|date_between:1500-01-01,${limitDate}`"
                       class="form-control form-control-sm"
                       name="dataFalecimento"
                       :disabled="disabled"
                       type="date"
                       @change="updated">
                <small class="invalid-feedback">{{ errors.first(`dataFalecimento-${id}_${ _uid }`) }}</small>
              </div>
            </div>
          </div>
        </div>

        <div v-if="localData.exterior == true && !enderecoDisable"
             class="row">
          <div class="col-2">
            <div v-if="!localData.exterior"
                 class="form-group">
              <label for="pais"
                     class="label">Pais</label>
              <v-select v-model="localData.pais"
                        v-validate="{ required: !valid }"
                        :options="selectsOptions.paises.map(res => res.nome)"
                        :class="{ 'is-invalid': errors.has('pais') }"
                        class="form-control form-control-sm"
                        name="pais"
                        :disabled="disabled || !localData.exterior"
                        @input="paisChanged" />
            </div>
          </div>
          <div class="col-5">
            <div v-if="!localData.exterior"
                 class="form-group">
              <label class="label"
                     :for="`endereco-${id}_${ _uid }`">Endereço</label>
              <input :id="`endereco-${id}_${ _uid }`"
                     ref="logradouro"
                     v-model="localData.logradouro"
                     class="form-control form-control-sm"
                     name="endereco"
                     placeholder="Rua Alguma Coisa"
                     :disabled="disabled"
                     type="text"
                     @change="updated">
            </div>
          </div>
          <div v-if="!!propGenitorFalecido"
               class="col-3">
            <div class="form-group">
              <label class="label"
                     :for="`dataFalecimento-${id}_${ _uid }`">Data do falecimento</label>
              <input :id="`dataFalecimento-${id}_${ _uid }`"
                     ref="dataFalecimento"
                     v-model="data_falecimento"
                     v-validate="`date_format:yyyy-MM-dd|date_between:1500-01-01,${limitDate}`"
                     class="form-control form-control-sm"
                     name="dataFalecimento"
                     :disabled="disabled"
                     type="date"
                     @change="updated">
              <small class="invalid-feedback">{{ errors.first(`dataFalecimento-${id}_${ _uid }`) }}</small>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  /* services */
  import EnderecosService from "@/services/Enderecos"
  import NacionalidadesService from "@/services/NacionalidadesService"

  /* constants */
  import BrazilianStates from "@/constants/brazilianStates"
  import Cidades from "@/constants/repositorio/cidades"

  /* others */
  import moment from "moment"

  export default {
    name: 'BoxEndereco',
    inject: ['$validator'],
    props: {
      noHeader: Boolean,
      exteriorDisable: { type: Boolean, default: false },
      enderecoDisable: {type: Boolean, default: true},
      disabled: Boolean,
      data: { type: Object, default: () => ({})},
      propMostrarExterior: { type: Boolean, default: false },
      propValidator: { type: Boolean, default: false },
      propCartorio: { type: Object, default: () => { return {} } },
      propOtherCity: { type: Boolean, default: false},
      propLocalizacao: { type: Boolean, default: false},
      propGenitorFalecido: { type: Boolean, default: false },
      propLocalFalecimento: { type: Object, default: () => { return {} } }
    },
    data () {
      return {
        key: 'value',
        id: null,
        localData: {
          uf: '',
          cidade: '',
          pais: 'Brasil',
          codigo_pais: 76,
        },
        selectsOptions: {
          states: [...BrazilianStates],
          paises: []
        },
        cidades: [],
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        data_falecimento: null
      }
    },
    computed: {
      valid () {
        let isValid = false
        if (this.propValidator && (this.disabled || !this.localData.exterior)) {
          isValid = true
        }
        return isValid
      },
      showCadastroIbge () {
        let validCitie = false
        
        const stateSelected = this.selectsOptions.states.find(state => state.uf == this.localData.uf) 

        if (stateSelected && stateSelected.uf !== 'EX' && this.localData.cidade)  {
          const cities = Cidades.filter(cidade => cidade.codigo_uf == stateSelected.ibgeId)
          const cidade = cities.find(cidade => cidade.nome == this.localData.cidade)

          if (!cidade && this.localData.cidade != 'Outro') {
            this.$validator.validate()
            validCitie = true
          }  
        }
        return validCitie
      }
    },
    watch: {
      data () {
        if (this.data) this.localData = this.data
        if (this.localData && this.localData.uf) this.getCities()
        if (this.localData && this.localData.exterior) this.getPais()
      },
      propLocalFalecimento () {
        if (Object.keys(this.propLocalFalecimento).length !== 0 && !!this.propGenitorFalecido) {
          this.data_falecimento = this.propLocalFalecimento.data_falecimento ? this.propLocalFalecimento.data_falecimento : null
        }
      },
      disabled (val) {
        let container = this.$el
        let tags = container.querySelectorAll(".multiselect__tags")
        if (tags) {
          for (const tag of tags) {
            tag.style["background-color"] = (val) ? "rgb(223, 224, 225)" : "#fff"
          }
        }
      },
      exteriorDisable () {
        this.localData = {
          ...this.localData,
          exterior: this.exteriorDisable
        }
      }
    },
    mounted () {
      this.id = this._uid
      if (this.localData.uf) this.getCities()
      if (this.localData.exterior) this.loadPaises()
    },
    created () {
      if (this.data) this.localData = this.data
      this.verifyDataFalecimento()
      this.loadPaises()
    },
    methods: {
      triggerChange () {
        this.trigger = true
      },
      stateChanged () {
        this.localData.cidade = null
        this.localData.ibge = null
        this.localData.pais = null
        this.localData.codigo_pais = null
        this.localData.complemento = null
        //devem ser NULL para validacao na CRC
        this.updated()
        this.getCities()
      },
      async getCEP () {
        if (!this.localData.cep) return

        loader({ active: true })

        try {
          let data = await EnderecosService.getAddressByCEP(this.localData.cep)

          this.localData = {
            ...this.localData,
            cep: data.cep,
            logradouro: data.logradouro,
            bairro: data.bairro,
            uf: data.uf,
            cidade: data.localidade,
            ibge: data.ibge,
          }

          this.$validator.validate()
          this.$refs.numero.focus()
          this.getCities()
          this.updated()
          loader({ active: false })
        } catch (error) {
          this.$refs.logradouro.focus()
          this.updated()
          loader({ active: false })
        }
      },
      setExterior () {
        this.localData = {
          ...this.localData,
          exterior: this.localData.exterior,
          logradouro: this.localData.logradouro,
          bairro: null,
          cep: null,
          numero: null,
          complemento: null,
          cidade: null,
          uf: null,
          ibge: null,
          pais: null,
          codigo_pais: null
        }

        this.updated()
      },
      updated () {
        if (!this.localData.cidade) {
          this.localData.ibge = null
        }
        this.$emit('onEnderecoAdd', this.localData)

        if (!!this.propGenitorFalecido) {
          this.$emit('onDataFalecimentoAdd', this.data_falecimento)
        }
      },

      async getCities () {
        const stateSelected = this.selectsOptions.states.find(state => state.uf == this.localData.uf)

        if (stateSelected) {
          if (stateSelected.uf  && stateSelected.uf !== 'EX') {
            this.cidades = Cidades.filter(cidade => cidade.codigo_uf == stateSelected.ibgeId)
            this.cidades.push({nome: 'Outro'})
          }

          if (stateSelected.uf === 'EX') {
            this.cidades = [{nome: 'Outro'}]
            this.localData.cidade = 'Outro'
          }

          if (this.propOtherCity) this.cidades.push({nome: 'Outro'})
        }
      },
      paisChanged (nomePais) {
        let pais = this.selectsOptions.paises.find(pais => pais.nome == nomePais)

        this.localData.codigo_pais = pais.codigo

        this.updated()
      },
      getPais () {
        const pais = this.selectsOptions.paises.filter(pais => pais.codigo == this.localData.codigo_pais)
        if (pais.length) this.localData.pais = pais[0].nome
      },
      async loadPaises () {
        this.selectsOptions.paises = await NacionalidadesService.searchNacionalidadeByName("")
        this.getPais()
      },
      changeIbge () {
        if (this.localData.cidade) {
          const cidade = this.cidades.find(res => res.nome === this.localData.cidade)

          this.localData.ibge = cidade ? cidade.ibge : null

          this.$validator.validate()

          this.updated()
        } else {
          this.getCities()
        }
      },
      search (event) {
        const { key } = event

        if (key == 'Tab' || key == 'Enter') {
          this.getCEP()
        }
      },
      async getCoords () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(res => getAddress(res.coords))
        }
        else {
          console.error('Geolocalização não é suportada neste Browser/OS.')
        }

        const getAddress = async (coords) => {
          const { latitude, longitude } = coords
          try {
            loader({text: "", active: true})

            const res = await EnderecosService.getLocation(latitude, longitude)

            const {address} = res

            if (address) {
              const state = BrazilianStates.find(state => state.name == address.state)

              this.localData = {
                ...this.localData,
                cep: address.postcode,
                logradouro: address.road,
                numero: '',
                complemento: '',
                bairro: address.suburb,
                cidade: address.city,
                uf: state ? state.uf : null,
                ibge: state ? state.ibgeId : null,
              }

              this.$validator.validate()
              this.$refs.numero.focus()
              this.getCities()
              this.updated()
            }

          } catch (error) {
            objSwal.error.title = ""
            objSwal.error.text = "Não foi possível obter a localização."
            objSwal.error.html = ""

            Swal.fire(objSwal.error)
          } finally {
            loader({text: "", active: false})
          }
        }
      },
      changeExterior () {
        setTimeout(() => {
          this.localData.exterior = !this.localData.exterior

          this.setExterior()
        }, 200)
      },
      verifyDataFalecimento () {
        if (!!this.propGenitorFalecido) {
          if (Object.keys(this.propLocalFalecimento).length !== 0) {
            this.data_falecimento = this.propLocalFalecimento.data_falecimento ? this.propLocalFalecimento.data_falecimento : null
          }
        }
      }

    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';

  .boxCadastroEndereco {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;
    }
  }

  .multiselect > input:disabled {
    background-color: #e9ecef;
  }

  .select-invalid .multiselect__tags{
    border: 1px solid red !important;
    border-radius: 5px !important;
    border-color: #ED0909 !important;
  }

  .text-invalid {
    color: #ED0909;
  }

  .icon-location {
    fill: #1E4C89;
    width: 20px;
    height: 20px;
  }

  .btn-get-coord:hover > [class*=icon-location] {
    fill: #fff !important;
  }
</style>
